import { AttributeInfo, AttributeRequirement } from 'src/app/types/@types/sl-v-types';
import { AttributesService, QSLookup, AttStorageType } from '../api-services/attributes.service';
import { Formatters, Column } from 'angular-slickgrid';
import { HyperLinkFormatter } from './hyperlink-formatter';
import { AggOrder } from '../agg-order';
import { CastingFormatType } from 'src/app/components/att-casting-view/formats/casting-formats-sel/casting-formats-sel.component';
import { CastingValue } from 'src/app/components/att-casting-view/att-casting-view.component';
import { FractionalLabelMode, FractionalMode } from 'src/app/components/att-casting-view/formats/fractional-values-sel/fractional-values-sel.component';
import { NumberFractionQualifierService } from '../api-services/qualifiers/number-fraction-qualifier.service';
import { AggregatorSet } from '../aggregators/aggregator-set';
import { Dict } from 'src/app/types/decorable';
import { DateQualifierService } from '../api-services/qualifiers/date-qualifier.service';


export class ColumnFormatter {
  static Format(row: number, cell: number, value: any, columnDef?: any, dataContext?: any, gridRef?: any): string {
    if ([null, undefined, NaN].indexOf(value) > -1) { value = ''; }
    const rawMode: boolean = (!!columnDef.params && !!columnDef.params.rawMode) ? columnDef.params.rawMode : false;
    if (rawMode === true) {
      return value;
    }

    const attribute: AttributeInfo = (!!columnDef.params && !!columnDef.params.attribute) ? columnDef.params.attribute : null;
    if (!attribute) {
      return value;
    }
    if (!!attribute.casting) {
      // const rawValue = AttributesService.GetValue(attribute, value);
      const displayValue = AttributesService.GetDisplayValue(attribute, value);// rawValue);
      return ColumnFormatter.StatDecorator(displayValue, dataContext, columnDef);
    }

    let type: AttStorageType | AttributeRequirement = attribute.type === undefined ? attribute.requires : attribute.type;
    if (attribute.requires === 'url') {
      type = 'url';
    }
    if ([undefined, null, NaN, ''].indexOf(value) > -1) {
      return '';
    }
    switch (type) {
      case 'cg_url':
      case 'url':
        return HyperLinkFormatter.Format(row, cell, value, columnDef, dataContext);
      case 'time':
        return DateQualifierService.ToString(value, 'date#01:30 PM');
      case 'date':

        if (value instanceof Date) {
          return DateQualifierService.ToString(value, 'date#2345-03-04');
        } else {
          return DateQualifierService.ToString(DateQualifierService.DBToDate(value), 'date#2345-03-04');
        }

        break;
      case 'boolean':
        return '' + Formatters.checkmark(row, cell, value, columnDef, dataContext, gridRef);
      case 'numeric':
      case 'float':
      case 'int':
      case 'integer':
        return ColumnFormatter.StatDecorator(value, dataContext, columnDef);
      case 'text':
      case 'string':
      default:
        return value;


    }
  }

  static GetExcelFormat(attribute) {
    /*if (!!attribute.casting) {
      /const rawValue = AttributesService.GetValue(attribute, value);
      return AttributesService.GetDisplayValue(attribute, rawValue, true);// rawValue);

      // return ColumnFormatter.StatDecorator(displayValue, dataContext, columnDef);
    }*/
  }

  static FormatText(value: any, attribute: AttributeInfo): string {
    if (!value) return '';
    const attName = attribute.name;
    // const attribute: AttributeInfo = (!!columnDef.params && !!columnDef.params.attribute) ? columnDef.params.attribute : null;
    if (!attribute) {
      return '';
    }
    if (!!attribute.casting) {
      // const rawValue = AttributesService.GetValue(attribute, value);
      return AttributesService.GetDisplayValue(attribute, value[attName], true);// rawValue);

      // return ColumnFormatter.StatDecorator(displayValue, dataContext, columnDef);
    }

    let type: AttStorageType | AttributeRequirement = attribute.type === undefined ? attribute.requires : attribute.type;
    if (attribute.requires === 'url') {
      type = 'url';
    }

    switch (type) {
      case 'cg_url':
      case 'url':
        return value[attName];
      case 'time':
      case 'date':
        if (!value[attName]) {
          return '';
        }
        if (typeof value[attName] === 'string') {
          return value[attName];
        }
        return (value[attName] as Date).toISOString();
        break;
      case 'boolean':
        if (typeof value[attName]) {
          return value[attName];
        }
        return value[attName] === true ? 'true' : 'false';
      case 'numeric':
      case 'float':
      case 'int':
      case 'integer':
        return value[attName];
      case 'text':
      case 'string':
      default:
        return value[attName];


    }
  }
  static TextWidth(text: string, fontSize?: string): number {
    let element = document.getElementById('fitContent');
    let maxWidth = 0;
    if (!element) {
      const e = document.createElement('div');
      document.body.append(e);
      e.id = 'fitContent';
      if (!!fontSize) {
        e.style.setProperty('font-size', fontSize);
      }
      element = e;
    }
    element.innerHTML = text;
    return element.clientWidth;
  }
  static FitWidth(dataSet: any, aggSet: AggregatorSet, columnDef: Column<any>, pxFontSize: number = 14, _dataContext?: any, _gridRef?: any): number {
    let element = document.getElementById('fitContent');
    let maxWidth = 0;
    if (!element) {
      const e = document.createElement('div');
      document.body.append(e);
      e.id = 'fitContent';

      element = e;
    }
    element.innerHTML = 'M'.repeat(255);
    maxWidth = element.clientWidth;

    const fontSize = '14px';

    let width = 0;
    for (const item of dataSet) {
      if (item.hasOwnProperty(columnDef.id)) {
        element.style['font-size'] = fontSize;
        element.innerHTML = ColumnFormatter.Format(-1, -1, item[columnDef.id], columnDef, _dataContext, _gridRef);
        width = Math.max(element.clientWidth, width);
      }
    }
    if (!!aggSet) {
      const value: Dict = aggSet.GetValue();
      for (const aggName in value) {
        if (value.hasOwnProperty(aggName)) {
          const agg = value[aggName];
          if (agg && agg.hasOwnProperty(columnDef.id)) {
            element.innerHTML = ColumnFormatter.Format(-1, -1, agg[columnDef.id], columnDef, _dataContext, _gridRef);
            width = Math.max(element.clientWidth, width);
          }
        }
      }
    }
    element.innerHTML = ColumnFormatter.FormatHeader(columnDef.params.attribute);
    const headerWidth = element.clientWidth + 24;
    const contentWidth = Math.min(maxWidth, width);
    return Math.max(headerWidth, contentWidth);
    /*if (!value) { return 100 }

    const rawMode: boolean = (!!columnDef.params && !!columnDef.params.rawMode) ? columnDef.params.rawMode : false;
    if (rawMode === true) {

      return value;
    }

    const attribute: AttributeInfo = (!!columnDef.params && !!columnDef.params.attribute) ? columnDef.params.attribute : null;

    if (!!attribute.casting) {
      const rawValue = AttributesService.GetValue(attribute, value);
      const displayValue = AttributesService.GetDisplayValue(attribute, rawValue);
      return ColumnFormatter.StatDecorator(displayValue, dataContext, columnDef);
    }

    let type: AttStorageType | AttributeRequirement = attribute.type === undefined ? attribute.requires : attribute.type;
    if (attribute.requires === 'url') {
      type = 'url';
    }

    switch (type) {
      case 'cg_url':
      case 'url':
        return HyperLinkFormatter.Format(row, cell, value, columnDef, dataContext);
      case 'time':
      case 'date':
        return '' + Formatters.dateTimeIso(row, cell, value, columnDef, dataContext, gridRef);
        break;
      case 'boolean':
        return '' + Formatters.checkmark(row, cell, value, columnDef, dataContext, gridRef);
      case 'numeric':
      case 'float':
      case 'int':
      case 'integer':
        return ColumnFormatter.StatDecorator(value, dataContext, columnDef);
      case 'text':
      case 'string':
      default:
        return value;


    }*/
  }
  static FormatHeader(attribute: AttributeInfo): string {
    if (!attribute.casting) {
      return attribute.display;
    }
    let type: CastingFormatType = null;
    let value: CastingValue = null;
    if (attribute.casting.display && attribute.casting.display.type) {
      type = attribute.casting.display.type;
      value = attribute.casting.display;

    } else if (attribute.casting.entry && attribute.casting.entry.type) {
      type = attribute.casting.entry.type;
      value = attribute.casting.entry;
    }
    if (type === null) {
      return attribute.display;
    }
    if (!!value.fractional) {
      return NumberFractionQualifierService.ToHeader(attribute.display, value.fractional);
    }
    return attribute.display;
  }

  static StatDecorator(value, dataContext, columnDef) {

    if (!!dataContext && !!dataContext.__stats) {
      if (!!dataContext.__stats[columnDef.id]) {
        if (!!dataContext.__stats[columnDef.id].zScore) {
          const zScore = dataContext.__stats[columnDef.id].zScore;
          const icon = ColumnFormatter.MakeZScoreIcon(zScore);
          return `${value} ${icon}`;
        }
      }
    }

    return value;
  }
  static MakeZScoreIcon(zScore) {
    let score = zScore;
    if (score !== 0) {
      for (let ctr = -3; ctr < 4; ctr++) {
        if (score < ctr) {
          score = (ctr <= 0) ? ctr - 1 : ctr;
          break;
        }
      }
    }
    if (score < -3) {
      score = -4;
    } else if (score > 3) {
      score = 4;
    }
    let dev = 'pos' + score;
    if (score === 0) {
      dev = 'median';
    } else if (score < 0) {
      dev = 'neg' + Math.abs(score);
    }
    const valueStr = `<div id="z-score" class="z-score dev-${dev}">
  <div class="std-dist std-dev-neg3 neg"></div>
  <div class="std-dist std-dev-neg2 neg"></div>
  <div class="std-dist std-dev-neg1 neg"></div>
  <div class="std-dist std-dev-median med"></div>
  <div class="std-dist std-dev-pos1 pos"></div>
  <div class="std-dist std-dev-pos2 pos"></div>
  <div class="std-dist std-dev-pos3 pos"></div>
</div>`;
    return valueStr;
  }

}
